<template>
  <div v-if="currentOf">
    <div class="mt-4 mb-4">
      <div role="tablist">
        <Etape
          v-for="(etape, index) in currentOf.item_lists"
          :key="index"
          :currentEtape="etape"
          :currentIndex="index + 1"
          @onDemarrer="demarrer"
          @onCloturer="terminer"
          @onPause="pause"
          @onRedemarrer="pause"
          @onReinitialiser="reinitialiser"
        />
      </div>
    </div>
    <ModalLancement
      ref="modalLancement"
      :currentEtape="currentEtape"
      :currentIndex="currentIndex"
      @onInit="init"
    />
    <ModalCloture
      ref="modalCloture"
      :currentEtape="currentEtape"
      :currentIndex="currentIndex"
      @onInit="init"
    />
  </div>
</template>

<script>
import URL_O from '@/http/gpao/of';
import URL_E from '@/http/gpao/of-etape';
import Etape from './Etape.vue';
import ModalLancement from '../../etape/modals/ModalLancement.vue';
import ModalCloture from '../../etape/modals/ModalCloture.vue';
export default {
  data() {
    return {
      id: null,
      currentOf: null,
      currentEtape: null,
      currentIndex: null,
    };
  },
  components: {
    Etape,
    ModalLancement,
    ModalCloture,
  },
  methods: {
    reinitialiser(currentEtape) {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_E.REINITIALISER + '/' + currentEtape.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    demarrer(currentEtape, currentIndex) {
      this.currentEtape = currentEtape;
      this.currentIndex = currentIndex;
      this.$refs.modalLancement.showModal();
    },
    pause(currentEtape) {
      this.showConfirmValidation().then((result) => {
        if (result.value) {
          window.axios
            .put(URL_E.PAUSE + '/' + currentEtape.id)
            .then((resp) => {
              this.showSimpleAlerte('top-end', 'success', resp.data.message);
              this.init();
            })
            .catch();
        }
      });
    },
    terminer(currentEtape, currentIndex) {
      this.currentEtape = currentEtape;
      this.currentIndex = currentIndex;
      this.$refs.modalCloture.showModal();
    },
    init() {
      this.id = this.$route.params.id;
      this.currentOf = null;
      window.axios
        .get(URL_O.OF + '/' + this.id, { params: { suivi_of: true } })
        .then((resp) => {
          this.currentOf = resp.data.of;
        })
        .catch();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.list-group-item.active,
.list-group-item.active:hover {
  border-color: #f4c334 !important;
  background-color: #ffffff;
  color: black;
}

::v-deep .pagination .page-link {
  /*background: #f4c334 ;*/
  color: #363636;
}
::v-deep .pagination .active button {
  background: #f4c334;
  border: #f4c334 1px solid;
}

/***** */

.card-header .accicon {
  float: right;
}
.card-header {
  cursor: pointer;
  border-bottom: 5px;
}
.card {
  border: 1px solid #ddd;
}

.bg-silver {
  background-color: transparent;
  border-color: #ced4da;
}

.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
